import React, { useContext } from "react";
import {
  Navbar,
  NavbarLink,
  NavbarLeft,
  NavbarLine,
  NavbarLogo,
  NavbarRight,
  NavbarSectionContainer,
  ThemeToggle,
} from "./style";

import Logo from "../../../../assets/images/logo.svg";
import { NavbarSectionProps } from "./props";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../../context/theme-context";

const navbarItems = [
  {
    name: "Thoughts",
    link: "/thoughts",
  },
  {
    name: "About",
    link: "/about",
  },
  {
    name: "CV",
    link: "/cv",
  },
];

const renderNavbarItems = () =>
  navbarItems.map((n) => (
      <NavbarLink key={n.name} to={n.link}>
        {n.name}
      </NavbarLink>
  ));

const NavbarSection = (props: NavbarSectionProps) => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <NavbarSectionContainer>
      <Navbar>
        <NavbarLeft>
          <Link to="/">
            <NavbarLogo src={Logo} />
          </Link>
        </NavbarLeft>
        <NavbarRight>
          {renderNavbarItems()}
          <ThemeToggle
            type="button"
            onClick={toggleTheme}
            aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
            title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
          >
            {theme === "light" ? (
              <svg viewBox="0 0 20 20" aria-hidden="true">
                <path
                  d="M16.4 12.5A6.7 6.7 0 0 1 7.5 3.6 6.8 6.8 0 1 0 16.4 12.5Z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg viewBox="0 0 20 20" aria-hidden="true">
                <circle
                  cx="10"
                  cy="10"
                  r="3.5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                />
                <path
                  d="M10 2.2v2.1M10 15.7v2.1M17.8 10h-2.1M4.3 10H2.2M15.5 4.5 14 6M6 14l-1.5 1.5M15.5 15.5 14 14M6 6 4.5 4.5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </ThemeToggle>
        </NavbarRight>
      </Navbar>
      {props.showLine && <NavbarLine percentage={props.percentage} />}
    </NavbarSectionContainer>
  );
};

export default NavbarSection;
